var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-orange"},[_c('img',{staticClass:"line line-top",attrs:{"src":"img/section-line-top.png","alt":""}}),_vm._t("default"),(this.$route.path !== '/big-expedition')?_c('img',{staticClass:"line line-bottom",attrs:{"src":"img/section-line-bottom.png","alt":""}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }